/**
 * 请求状态
 */
export const STATUS_PROGRESS = 'PROGRESS';
export type STATUS_PROGRESS = typeof STATUS_PROGRESS;
export const STATUS_PENDING = 'PENDING';
export type STATUS_PENDING = typeof STATUS_PENDING;
export const STATUS_SUCCESS = 'SUCCESS';
export type STATUS_SUCCESS = typeof STATUS_SUCCESS;
export const STATUS_ERROR = 'ERROR';
export type STATUS_ERROR = typeof STATUS_ERROR;
export const STATUS_FAILURE = 'FAILURE';
export type STATUS_FAILURE = typeof STATUS_FAILURE;
export type FETCH_STATUS = STATUS_PROGRESS | STATUS_SUCCESS | STATUS_ERROR | STATUS_PENDING | STATUS_FAILURE;
// export type FETCH_STATUS = STATUS_RELOAD | STATUS_REQUEST | STATUS_SUCCESS | STATUS_FAILURE;

export const DRUGSTORE_STATUS_RELOAD = 'DRUGSTORE_STATUS_RELOAD';
export const DRUGSTORE_STATUS_REQUEST = 'DRUGSTORE_STATUS_REQUEST';
export const DRUGSTORE_STATUS_SUCCESS = 'DRUGSTORE_STATUS_SUCCESS';
export const DRUGSTORE_STATUS_FAILURE = 'DRUGSTORE_STATUS_FAILURE';
export type DRUGSTORE_STATUS_RELOAD = typeof DRUGSTORE_STATUS_RELOAD;
export type DRUGSTORE_STATUS_REQUEST = typeof DRUGSTORE_STATUS_REQUEST;
export type DRUGSTORE_STATUS_SUCCESS = typeof DRUGSTORE_STATUS_SUCCESS;
export type DRUGSTORE_STATUS_FAILURE = typeof DRUGSTORE_STATUS_FAILURE;
export type FETCH_DRUGSTORE_STATUS = DRUGSTORE_STATUS_RELOAD | DRUGSTORE_STATUS_REQUEST | DRUGSTORE_STATUS_SUCCESS | DRUGSTORE_STATUS_FAILURE;

export const PROVINCE_STATUS_RELOAD = 'PROVINCE_STATUS_RELOAD';
export const PROVINCE_STATUS_REQUEST = 'PROVINCE_STATUS_REQUEST';
export const PROVINCE_STATUS_SUCCESS = 'PROVINCE_STATUS_SUCCESS';
export const PROVINCE_STATUS_FAILURE = 'PROVINCE_STATUS_FAILURE';
export type PROVINCE_STATUS_RELOAD = typeof PROVINCE_STATUS_RELOAD;
export type PROVINCE_STATUS_REQUEST = typeof PROVINCE_STATUS_REQUEST;
export type PROVINCE_STATUS_SUCCESS = typeof PROVINCE_STATUS_SUCCESS;
export type PROVINCE_STATUS_FAILURE = typeof PROVINCE_STATUS_FAILURE;
export type FETCH_PROVINCE_STATUS = PROVINCE_STATUS_RELOAD | PROVINCE_STATUS_REQUEST | PROVINCE_STATUS_SUCCESS | PROVINCE_STATUS_FAILURE;

// export const PRICE_MODE_STATUS_RELOAD = 'PRICE_MODE_STATUS_RELOAD';
// export const PRICE_MODE_STATUS_REQUEST = 'PRICE_MODE_STATUS_REQUEST';
// export const PRICE_MODE_STATUS_SUCCESS = 'PRICE_MODE_STATUS_SUCCESS';
// export const PRICE_MODE_STATUS_FAILURE = 'PRICE_MODE_STATUS_FAILURE';
// export type PRICE_MODE_STATUS_RELOAD = typeof PRICE_MODE_STATUS_RELOAD;
// export type PRICE_MODE_STATUS_REQUEST = typeof PRICE_MODE_STATUS_REQUEST;
// export type PRICE_MODE_STATUS_SUCCESS = typeof PRICE_MODE_STATUS_SUCCESS;
// export type PRICE_MODE_STATUS_FAILURE = typeof PRICE_MODE_STATUS_FAILURE;
// export type FETCH_PRICE_MODE_STATUS = PRICE_MODE_STATUS_RELOAD | PRICE_MODE_STATUS_REQUEST | PRICE_MODE_STATUS_SUCCESS | PRICE_MODE_STATUS_FAILURE;

// export const PHARMACY_STATUS_RELOAD = 'PHARMACY_STATUS_RELOAD';
// export const PHARMACY_STATUS_REQUEST = 'PHARMACY_STATUS_REQUEST';
// export const PHARMACY_STATUS_SUCCESS = 'PHARMACY_STATUS_SUCCESS';
// export const PHARMACY_STATUS_FAILURE = 'PHARMACY_STATUS_FAILURE';
// export type PHARMACY_STATUS_RELOAD = typeof PHARMACY_STATUS_RELOAD;
// export type PHARMACY_STATUS_REQUEST = typeof PHARMACY_STATUS_REQUEST;
// export type PHARMACY_STATUS_SUCCESS = typeof PHARMACY_STATUS_SUCCESS;
// export type PHARMACY_STATUS_FAILURE = typeof PHARMACY_STATUS_FAILURE;
// export type FETCH_PHARMACY_STATUS = PHARMACY_STATUS_RELOAD | PHARMACY_STATUS_REQUEST | PHARMACY_STATUS_SUCCESS | PHARMACY_STATUS_FAILURE;

// export const MEDICINE_STATUS_RELOAD = 'MEDICINE_STATUS_RELOAD';
// export const MEDICINE_STATUS_REQUEST = 'MEDICINE_STATUS_REQUEST';
// export const MEDICINE_STATUS_SUCCESS = 'MEDICINE_STATUS_SUCCESS';
// export const MEDICINE_STATUS_FAILURE = 'MEDICINE_STATUS_FAILURE';
// export type MEDICINE_STATUS_RELOAD = typeof MEDICINE_STATUS_RELOAD;
// export type MEDICINE_STATUS_REQUEST = typeof MEDICINE_STATUS_REQUEST;
// export type MEDICINE_STATUS_SUCCESS = typeof MEDICINE_STATUS_SUCCESS;
// export type MEDICINE_STATUS_FAILURE = typeof MEDICINE_STATUS_FAILURE;
// export type FETCH_MEDICINE_STATUS = MEDICINE_STATUS_RELOAD | MEDICINE_STATUS_REQUEST | MEDICINE_STATUS_SUCCESS | MEDICINE_STATUS_FAILURE;

// export const STATUS_RELOAD = 'STATUS_RELOAD'
// export const STATUS_REQUEST = 'STATUS_REQUEST';
// export const STATUS_SUCCESS = 'STATUS_SUCCESS';
// export const STATUS_FAILURE = 'STATUS_FAILURE';
// export type STATUS_RELOAD = typeof STATUS_RELOAD;
// export type STATUS_REQUEST = typeof STATUS_REQUEST;
// export type STATUS_SUCCESS = typeof STATUS_SUCCESS;
// export type STATUS_FAILURE = typeof STATUS_FAILURE;
// export type FETCH_STATUS = STATUS_RELOAD | STATUS_REQUEST | STATUS_SUCCESS | STATUS_FAILURE;

export const DATA_CLEAR = 'DATA_CLEAR';
export type DATA_CLEAR = typeof DATA_CLEAR;

/**
 * 登录用户
 */
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export type LOGIN_SUCCESS = typeof LOGIN_SUCCESS;
/**
 * 登录失败
 */
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export type LOGIN_FAILURE = typeof LOGIN_FAILURE;
/**
 * 登出用户
 */
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export type LOGOUT_SUCCESS = typeof LOGOUT_SUCCESS;
/**
 * 登出失败
 */
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export type LOGOUT_FAILURE = typeof LOGOUT_FAILURE;

/**
 * 清空登录信息
 */
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export type NOT_LOGGED_IN = typeof NOT_LOGGED_IN;

export type AUTH_STATUS = LOGIN_SUCCESS | LOGIN_FAILURE | LOGOUT_SUCCESS | LOGOUT_FAILURE | NOT_LOGGED_IN;

/**
 * 语言类型
 */
export const LANGUAGE_DOMESTIC = 'LANGUAGE_DOMESTIC';
export type LANGUAGE_DOMESTIC = typeof LANGUAGE_DOMESTIC;
export const LANGUAGE_FOREIGN = 'LANGUAGE_FOREIGN';
export type LANGUAGE_FOREIGN = typeof LANGUAGE_FOREIGN;
export const LANGUAGE_NAME = 'LANGUAGE_NAME';
export type LANGUAGE_NAME = typeof LANGUAGE_NAME;
export type LANGUAGE_TYPE = LANGUAGE_DOMESTIC | LANGUAGE_FOREIGN | LANGUAGE_NAME;

/**
 * 用户身份： 代理商
 */
export const USER_TYPE_AGENT = 'AGENT';
export type USER_TYPE_AGENT = typeof USER_TYPE_AGENT;
/**
 * 用户身份：配药中心
 */
export const USER_TYPE_DRUG_STORE = 'DRUG_STORE';
export type USER_TYPE_DRUG_STORE = typeof USER_TYPE_DRUG_STORE;
/**
 * 医生详情类型
 */
export const DOCTOR_TYPE_ISCERTIFICATED = 'ISCERTIFICATED';
export type DOCTOR_TYPE_ISCERTIFICATED = typeof DOCTOR_TYPE_ISCERTIFICATED;
export const DOCTOR_TYPE_ISPASS = 'ISPASS';
export type DOCTOR_TYPE_ISPASS = typeof DOCTOR_TYPE_ISPASS;
export const DOCTOR_TYPE_REJECT = 'REJECT';
export type DOCTOR_TYPE_REJECT = typeof DOCTOR_TYPE_REJECT;
export const DOCTOR_TYPE_DETAIL = 'DETAIL';
export type DOCTOR_TYPE_DETAIL = typeof DOCTOR_TYPE_DETAIL;
export const DOCTOR_TYPE_LIST = 'LIST';
export type DOCTOR_TYPE_LIST = typeof DOCTOR_TYPE_LIST;
export type DOCTOR_DETAIL_SOURCE = DOCTOR_TYPE_ISCERTIFICATED | DOCTOR_TYPE_ISPASS | DOCTOR_TYPE_DETAIL | DOCTOR_TYPE_LIST | DOCTOR_TYPE_REJECT;
/**
 * 选中记录状态
 */
export const DOCTOR_SELECT = 'DOCTOR_SELECT'; // 选中状态
export type DOCTOR_SELECT = typeof DOCTOR_SELECT;
export const DOCTOR_INVALIDATE = 'DOCTOR_INVALIDATE'; // 失效状态
export type DOCTOR_INVALIDATE = typeof DOCTOR_INVALIDATE;
export type DOCTOR_STATUS = DOCTOR_SELECT | DOCTOR_INVALIDATE;

export const ORDER_INFO_SELECT = 'ORDER_INFO_SELECT';
export type ORDER_INFO_SELECT = typeof ORDER_INFO_SELECT;
export const ORDER_INFO_INVALIDATE = 'ORDER_INFO_INVALIDATE';
export type ORDER_INFO_INVALIDATE = typeof ORDER_INFO_INVALIDATE;
export type ORDER_INFO_STATUS = ORDER_INFO_SELECT | ORDER_INFO_INVALIDATE;

export const RECHARGE_SUCCESS = 'RECHARGE_SUCCESS';
export type RECHARGE_STATUS = typeof RECHARGE_SUCCESS;

/**
 * websocket
 */
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export type RECEIVE_MESSAGE = typeof RECEIVE_MESSAGE;

/**
 * SlideMenu
 */
export const UPDATE_MENU = 'UPDATE_MENU';
export type UPDATE_MENU = typeof UPDATE_MENU;

/**
 * mall-药库
 */
export const MALL_PHARMACY_STATUS_RELOAD = 'MALL_PHARMACY_STATUS_RELOAD';
export const MALL_PHARMACY_STATUS_REQUEST = 'MALL_PHARMACY_STATUS_REQUEST';
export const MALL_PHARMACY_STATUS_SUCCESS = 'MALL_PHARMACY_STATUS_SUCCESS';
export const MALL_PHARMACY_STATUS_FAILURE = 'MALL_PHARMACY_STATUS_FAILURE';
export type MALL_PHARMACY_STATUS_RELOAD = typeof MALL_PHARMACY_STATUS_RELOAD;
export type MALL_PHARMACY_STATUS_REQUEST = typeof MALL_PHARMACY_STATUS_REQUEST;
export type MALL_PHARMACY_STATUS_SUCCESS = typeof MALL_PHARMACY_STATUS_SUCCESS;
export type MALL_PHARMACY_STATUS_FAILURE = typeof MALL_PHARMACY_STATUS_FAILURE;
export type FETCH_MALL_PHARMACY_STATUS =
  | MALL_PHARMACY_STATUS_RELOAD
  | MALL_PHARMACY_STATUS_REQUEST
  | MALL_PHARMACY_STATUS_SUCCESS
  | MALL_PHARMACY_STATUS_FAILURE;

/**
 * mall-类目
 */
export const MALL_CATEGORY_STATUS_RELOAD = 'MALL_CATEGORY_STATUS_RELOAD';
export const MALL_CATEGORY_STATUS_REQUEST = 'MALL_CATEGORY_STATUS_REQUEST';
export const MALL_CATEGORY_STATUS_SUCCESS = 'MALL_CATEGORY_STATUS_SUCCESS';
export const MALL_CATEGORY_STATUS_FAILURE = 'MALL_CATEGORY_STATUS_FAILURE';
export type MALL_CATEGORY_STATUS_RELOAD = typeof MALL_CATEGORY_STATUS_RELOAD;
export type MALL_CATEGORY_STATUS_REQUEST = typeof MALL_CATEGORY_STATUS_REQUEST;
export type MALL_CATEGORY_STATUS_SUCCESS = typeof MALL_CATEGORY_STATUS_SUCCESS;
export type MALL_CATEGORY_STATUS_FAILURE = typeof MALL_CATEGORY_STATUS_FAILURE;
export type FETCH_MALL_CATEGORY_STATUS =
  | MALL_CATEGORY_STATUS_RELOAD
  | MALL_CATEGORY_STATUS_REQUEST
  | MALL_CATEGORY_STATUS_SUCCESS
  | MALL_CATEGORY_STATUS_FAILURE;

/**
 * mall-品牌
 */
export const MALL_BRAND_STATUS_RELOAD = 'MALL_BRAND_STATUS_RELOAD';
export const MALL_BRAND_STATUS_REQUEST = 'MALL_BRAND_STATUS_REQUEST';
export const MALL_BRAND_STATUS_SUCCESS = 'MALL_BRAND_STATUS_SUCCESS';
export const MALL_BRAND_STATUS_FAILURE = 'MALL_BRAND_STATUS_FAILURE';
export type MALL_BRAND_STATUS_RELOAD = typeof MALL_BRAND_STATUS_RELOAD;
export type MALL_BRAND_STATUS_REQUEST = typeof MALL_BRAND_STATUS_REQUEST;
export type MALL_BRAND_STATUS_SUCCESS = typeof MALL_BRAND_STATUS_SUCCESS;
export type MALL_BRAND_STATUS_FAILURE = typeof MALL_BRAND_STATUS_FAILURE;
export type FETCH_MALL_BRAND_STATUS = MALL_BRAND_STATUS_RELOAD | MALL_BRAND_STATUS_REQUEST | MALL_BRAND_STATUS_SUCCESS | MALL_BRAND_STATUS_FAILURE;

/**
 * SPU-中药
 */
export const SPU_TCM_STATUS_RELOAD = 'SPU_TCM_STATUS_RELOAD';
export const SPU_TCM_STATUS_REQUEST = 'SPU_TCM_STATUS_REQUEST';
export const SPU_TCM_STATUS_SUCCESS = 'SPU_TCM_STATUS_SUCCESS';
export const SPU_TCM_STATUS_FAILURE = 'SPU_TCM_STATUS_FAILURE';
export type SPU_TCM_STATUS_RELOAD = typeof SPU_TCM_STATUS_RELOAD;
export type SPU_TCM_STATUS_REQUEST = typeof SPU_TCM_STATUS_REQUEST;
export type SPU_TCM_STATUS_SUCCESS = typeof SPU_TCM_STATUS_SUCCESS;
export type SPU_TCM_STATUS_FAILURE = typeof SPU_TCM_STATUS_FAILURE;
export type FETCH_SPU_TCM_STATUS = SPU_TCM_STATUS_RELOAD | SPU_TCM_STATUS_REQUEST | SPU_TCM_STATUS_SUCCESS | SPU_TCM_STATUS_FAILURE;

/**
 * SPU-中成药
 */
export const SPU_CPM_STATUS_RELOAD = 'SPU_CPM_STATUS_RELOAD';
export const SPU_CPM_STATUS_REQUEST = 'SPU_CPM_STATUS_REQUEST';
export const SPU_CPM_STATUS_SUCCESS = 'SPU_CPM_STATUS_SUCCESS';
export const SPU_CPM_STATUS_FAILURE = 'SPU_CPM_STATUS_FAILURE';
export type SPU_CPM_STATUS_RELOAD = typeof SPU_CPM_STATUS_RELOAD;
export type SPU_CPM_STATUS_REQUEST = typeof SPU_CPM_STATUS_REQUEST;
export type SPU_CPM_STATUS_SUCCESS = typeof SPU_CPM_STATUS_SUCCESS;
export type SPU_CPM_STATUS_FAILURE = typeof SPU_CPM_STATUS_FAILURE;
export type FETCH_SPU_CPM_STATUS = SPU_CPM_STATUS_RELOAD | SPU_CPM_STATUS_REQUEST | SPU_CPM_STATUS_SUCCESS | SPU_CPM_STATUS_FAILURE;

/**
 * 部门组织
 */
export const DEPARTMENT_STATUS_RELOAD = 'DEPARTMENT_STATUS_RELOAD';
export const DEPARTMENT_STATUS_REQUEST = 'DEPARTMENT_STATUS_REQUEST';
export const DEPARTMENT_STATUS_SUCCESS = 'DEPARTMENT_STATUS_SUCCESS';
export const DEPARTMENT_STATUS_FAILURE = 'DEPARTMENT_STATUS_FAILURE';
export type DEPARTMENT_STATUS_RELOAD = typeof DEPARTMENT_STATUS_RELOAD;
export type DEPARTMENT_STATUS_REQUEST = typeof DEPARTMENT_STATUS_REQUEST;
export type DEPARTMENT_STATUS_SUCCESS = typeof DEPARTMENT_STATUS_SUCCESS;
export type DEPARTMENT_STATUS_FAILURE = typeof DEPARTMENT_STATUS_FAILURE;
export const DEPARTMENT_MODIFY = 'DEPARTMENT_MODIFY';
export type DEPARTMENT_MODIFY = typeof DEPARTMENT_MODIFY;
export type DEPARTMENT_ACTION_TYPES = DEPARTMENT_STATUS_RELOAD |
  DEPARTMENT_STATUS_REQUEST |
  DEPARTMENT_STATUS_SUCCESS |
  DEPARTMENT_STATUS_FAILURE |
  DEPARTMENT_MODIFY;



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.ts